<template lang="pug">
el-dialog.border(
  :visible="isVisible",
  :title="titulo",
  :close-on-click-modal="false",
  :close-on-press-escape="false",
  :show-close="showClose",
  :width = "widthDialog",
  :before-close = 'beforeClose',
)
  slot
  .buttons
    .btn
      el-button(
        type="default",
        @click="$emit('cancelar')",
      )
        span.center
          i.fas.fa-times
          b &nbsp {{tituloBtnCancelar}}
      el-button(
        :disabled="disableConfirmar",
        type="default",
        @click="$emit('confirmar')"
      )
        span.end
          i.fas.fa-check
          b &nbsp {{tituloBtnConfirmar}}
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    titulo: {
      type: String,
      required: true
    },
    tituloBtnConfirmar: {
      type: String,
      default: 'Confirmar'
    },
    tituloBtnCancelar: {
      type: String,
      default: 'Cancelar'
    },
    widthDialog: {
      type: String,
      default: '50%'
    },
    showClose: {
      type: Boolean,
      default: false
    },
    disableConfirmar: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isVisible: 'dialog/isVisible'
    })
  },
  methods: {
    ...mapActions({
      setVisible: 'dialog/setVisible'
    }),
    beforeClose (done) {
      this.$emit('clearFields')
      this.setVisible(false)
      done()
    }
  }
}
</script>
<style scoped lang="scss">
.el-dialog {

  border-radius: 15px;

  .el-dialog__title {
    color: white;
  }

  // Alterando cor de fundo do componente
  .el-dialog__body {
    background-color: #ffffff;
    border-radius: 15px;
  }

  .el-dialog__header {
    background-color: #289f61;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  }

  .el-dialog__headerbtn {
    &:focus, &:hover{
      .el-dialog__close {
        color: #fff;
      }
    }
    .el-dialog__close {
      color: #fff;
    }
  }
}

.buttons {
  display: flex;
  justify-content: flex-end;
}

.btn {
  display: flex;
}

.center {
  display: flex;
  align-items: center;
}

.icon {
  font-size: 16px;
}

</style>



// WEBPACK FOOTER //
// src/components/AppDialog.vue